import React from 'react';
import './CardTwo.css';  // Import the CSS file for styling

function CardTwo({ img, title, points }) {
  return (
    <div className="card2">
      <img 
        src={img} 
        alt={title} 
        className="card2-image"
      />
      <div className="card2-content">
        <h3 className="card2-title">{title}</h3>
        <ul className="card2-points">
          {points.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default CardTwo;
